import { Formats } from '@utils/intl';
import { BOOKING_TYPE_MEETING_ROOM } from '@views/shared/consts';
import { useBaseValuesWithArea } from '@views/Book/Book/BasicBook/hooks';

export default function useValues(formats: Formats, message: string) {
  const result = useBaseValuesWithArea({
    formats,
    message,
    type: BOOKING_TYPE_MEETING_ROOM,
  });

  return {
    ...result,
    // we're using time slots, don't display time for meeting room on booking page
    time: undefined,
    // meeting room has always the hourly booking enabled
    enabledHourlyBooking: true,
    hasNextDaysBooking: false,
  };
}
